import { Component , Input } from '@angular/core';

@Component({
  selector: 'app-app-button',
  templateUrl: './app-button.component.html',
  styleUrls: ['./app-button.component.css']
})
export class AppButtonComponent {
  @Input() buttonText: string = '';
  @Input() disabled: boolean = false;
  @Input() link:string ='';
}
